var map = {
	"./circle_black.svg": 1026,
	"./circle_blue.svg": 1027,
	"./ellipse_black.svg": 1028,
	"./france.svg": 297,
	"./highlighted_yellow.svg": 1029,
	"./icons/Cart.svg": 1030,
	"./icons/Cart_add.svg": 1031,
	"./icons/Cart_delete.svg": 304,
	"./icons/Cart_remove.svg": 305,
	"./icons/_info.svg": 1032,
	"./icons/add_icon.svg": 306,
	"./icons/add_prod.svg": 1033,
	"./icons/add_prodOLD.svg": 1034,
	"./icons/ask.svg": 1035,
	"./icons/carousel.svg": 369,
	"./icons/clear_chart.svg": 307,
	"./icons/email.svg": 371,
	"./icons/facebook.svg": 148,
	"./icons/hatchef.svg": 360,
	"./icons/icone/_info.svg": 1036,
	"./icons/icone/book-open-solid.svg": 354,
	"./icons/icone/columns-solid.svg": 355,
	"./icons/icone/file-pdf-solid.svg": 357,
	"./icons/icone/hatchef.svg": 1037,
	"./icons/icone/info.svg": 1038,
	"./icons/icone/list-solid.svg": 359,
	"./icons/icone/magnifying-glass-solid.svg": 356,
	"./icons/icone/play.svg": 1039,
	"./icons/icone/plus.svg": 1040,
	"./icons/icone/share-square-solid.svg": 358,
	"./icons/icone/specs.svg": 1041,
	"./icons/icone/world.svg": 1042,
	"./icons/index-icon-bookmark.svg": 1043,
	"./icons/index-icon.svg": 1044,
	"./icons/info.svg": 368,
	"./icons/internal_link.svg": 372,
	"./icons/markers-SVG/ask.svg": 1045,
	"./icons/markers-SVG/info.svg": 1046,
	"./icons/markers-SVG/list.svg": 1047,
	"./icons/markers-SVG/recipe.svg": 1048,
	"./icons/markers-SVG/web.svg": 1049,
	"./icons/play.svg": 364,
	"./icons/play_ip.svg": 365,
	"./icons/plus.svg": 361,
	"./icons/plus_ip.svg": 362,
	"./icons/promo.svg": 367,
	"./icons/promo2.svg": 1050,
	"./icons/promo3.svg": 1051,
	"./icons/promo_10.svg": 1052,
	"./icons/promo_classic.svg": 1053,
	"./icons/remove_prod.svg": 308,
	"./icons/remove_prodOLD.svg": 1054,
	"./icons/remove_prod_.svg": 1055,
	"./icons/shop_list.svg": 1056,
	"./icons/specs.svg": 366,
	"./icons/telephone.svg": 370,
	"./icons/whatsapp.svg": 149,
	"./icons/world.svg": 363,
	"./logo_interattivo_free.svg": 1057,
	"./logo_volantinointerattivo_free.svg": 373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1025;